import React from 'react';
import { Link } from 'react-router-dom';
import './styles/Banner.css';
import img1 from '../../assets/skyford_uniform_banner.jpg';
import Stats from '../../layouts/Stats';
import brochure from '../../assets/brocheurs/Skyford_2026.pdf';
import LazyImage from '../common/LazyImage';

const Banner = () => {

  const downloadBrochure = async () => {
    try {
      const response = await fetch(brochure);
      const blob = await response.blob();
  
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Skyford_2026.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Failed to download brochure:', error);
    }
  };

  return (
    <>
      <div className="image-banner h-[50vh] sm:min-h-[85vh]">
        <div className="banner-slide">
          <div className="banner-image">
            <LazyImage 
              src={img1} 
              alt="Banner 1" 
              className="w-full h-full"
              priority={true}
              style={{ objectFit: 'cover' }}
            />
          </div>
        </div>
        <div className="banner-overlay bottom-20 flex flex-col-reverse sm:flex-row-reverse gap-4">
        <Link to='/contact'>
          <button className="banner-button font-medium bg-white text-[#F01923] flex items-center gap-2 px-6 py-3 rounded-full relative overflow-hidden group">
            <div className="absolute inset-0 w-full h-full bg-red-100 transform translate-x-full transition-transform duration-300 ease-out group-hover:translate-x-0" />
            <span className="relative z-10">Get Started</span>
            <svg 
              className="w-5 h-5 transform transition-transform duration-300 group-hover:-rotate-45 relative z-10" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M17 8l4 4m0 0l-4 4m4-4H3" 
              />
            </svg>
          </button>
        </Link>

        <button
          onClick={downloadBrochure}
          className="banner-button font-medium bg-white text-[#F01923] flex items-center gap-2 px-6 py-3 rounded-full relative overflow-hidden group"
        >
          <div className="absolute inset-0 w-full h-full bg-red-100 transform translate-x-full transition-transform duration-300 ease-out group-hover:translate-x-0" />
          <span className="relative z-10">Brochure</span>
          <svg
            className="w-5 h-5 relative z-10"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 4v12"
            />
          </svg>
        </button>
      </div>

      </div>
      <Stats />
    </>
  );
};

export default Banner;